// import React, { useState } from "react";
// import { FiMail, FiPhone, FiMapPin, FiX } from "react-icons/fi";
// import { useNavigate } from "react-router-dom";
// import emailjs from "@emailjs/browser";
// import { motion } from "framer-motion";

// const Contact = () => {
//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     message: "",
//   });

//   const navigate = useNavigate();
//   const handleClose = () => navigate("/");

//   const handleChange = (e) =>
//     setFormData({ ...formData, [e.target.name]: e.target.value });

//   const handleSubmit = (e) => {
//     e.preventDefault();

//     emailjs
//       .send(
//         "service_fz98ect",        // ✅ Your Service ID
//         "template_fyygjp7",       // ✅ Your Template ID
//         {
//           user_name: formData.name,
//           user_email: formData.email,
//           message: formData.message,
//         },
//         "a8Z9CQQmTYq1Zhy7j"       // ✅ Your Public Key
//       )
//       .then(
//         () => {
//           alert(`Thank you ${formData.name}, your message has been sent!`);
//           setFormData({ name: "", email: "", message: "" });
//         },
//         (error) => {
//           console.error("EmailJS Error:", error);
//           alert("Oops! Something went wrong, please try again.");
//         }
//       );
//   };

// return (
//   <div className="relative w-full min-h-screen bg-black pt-6 font-sans text-white">

//     {/* PAGE TITLE */}
//     <h1 className="text-center text-3xl sm:text-4xl md:text-5xl font-bold pt-16 pb-8 text-[#D4AF37] drop-shadow-[0_0_15px_rgba(212,175,55,0.4)]">
//       CONTACT US
//     </h1>

//     {/* MAIN SECTION */}
//     <section className="w-full bg-black py-16 px-5">
//       <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-14">

//         {/* LEFT SIDE */}
//         <motion.div
//           initial={{ opacity: 0, x: -100 }}
//           whileInView={{ opacity: 1, x: 0 }}
//           transition={{ duration: 0.7 }}
//         >
//           <p className="uppercase text-sm text-[#f5d68a] mb-3 tracking-wide">
//             Contact Us
//           </p>

//           <h2 className="text-3xl md:text-4xl font-bold text-[#D4AF37] leading-snug mb-6 drop-shadow-[0_0_15px_rgba(212,175,55,0.3)]">
//             Let us help your business <br /> move forward.
//           </h2>

//           <img
//             src="/con.jpeg"
//             alt="illustration"
//             className="w-80 md:w-96 rounded-xl shadow-[0_0_25px_rgba(212,175,55,0.3)]"
//           />
//         </motion.div>

//         {/* RIGHT - FORM */}
//         <motion.div
//           className="bg-black p-7 md:p-10 rounded-xl shadow-[0_0_30px_rgba(212,175,55,0.4)] border border-[#D4AF37]"
//           initial={{ opacity: 0, x: 100 }}
//           whileInView={{ opacity: 1, x: 0 }}
//           transition={{ duration: 0.7 }}
//         >
//           <h3 className="text-2xl font-semibold text-center text-[#f5d68a] mb-6">
//             Send Us a Message
//           </h3>

//           <form onSubmit={handleSubmit} className="space-y-5">
//             <input
//               type="text"
//               name="name"
//               placeholder="Your Name"
//               value={formData.name}
//               onChange={handleChange}
//               className="w-full p-3 bg-[#1a1a1a] text-white border border-[#D4AF37] rounded-md placeholder-gray-400 focus:ring-2 focus:ring-[#D4AF37]"
//               required
//             />

//             <input
//               type="email"
//               name="email"
//               placeholder="Your Email"
//               value={formData.email}
//               onChange={handleChange}
//               className="w-full p-3 bg-[#1a1a1a] text-white border border-[#D4AF37] rounded-md placeholder-gray-400 focus:ring-2 focus:ring-[#D4AF37]"
//               required
//             />

//             <textarea
//               name="message"
//               value={formData.message}
//               onChange={handleChange}
//               placeholder="Your Message"
//               rows="5"
//               className="w-full p-3 bg-[#1a1a1a] text-white border border-[#D4AF37] rounded-md placeholder-gray-400 focus:ring-2 focus:ring-[#D4AF37]"
//               required
//             ></textarea>

//             <motion.button
//               whileHover={{ scale: 1.05 }}
//               type="submit"
//               className="w-full bg-[#D4AF37] text-black py-3 rounded-md font-medium hover:bg-[#f5d68a] transition"
//             >
//               Submit Now
//             </motion.button>
//           </form>
//         </motion.div>
//       </div>
//     </section>

//     {/* BOTTOM INFO BOXES */}
//     <section className="w-full bg-black py-16 px-5">
//       <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-3 gap-8">

//         {/* OFFICE */}
//         <div className="bg-[#111] p-6 rounded-xl text-center text-white shadow-[0_0_20px_rgba(212,175,55,0.3)] border border-[#D4AF37] hover:scale-105 transition">
//           <FiMapPin className="text-red-600 text-3xl mx-auto mb-3" />

//           <a
//             href="https://www.google.com/maps/dir//Shagun+Arcade,+314,+PU+4,+Near+Vijay+Nagar+Square,+Vijay+Nagar,+Ratna+Lok+Colony,+Indore,+Madhya+Pradesh+452001"
//             className="text-white font-medium hover:text-red-600 text-sm sm:text-base break-all"
//           >
//             <h4 className="font-semibold mb-1">Our Office</h4>
//             <p className="opacity-90 text-sm">Indore, MP</p>
//           </a>
//         </div>

//         {/* EMAIL */}
//         <div className="bg-[#111] p-6 rounded-xl text-center text-white shadow-[0_0_20px_rgba(212,175,55,0.3)] border border-[#D4AF37] hover:scale-105 transition">
//           <FiMail className="text-red-400 text-2xl mx-auto mb-3" />

//           <a
//             href="https://mail.google.com/mail/?view=cm&fs=1&to=codexfuturetechnologies@gmail.com"
//             className="text-white font-medium hover:text-red-400 text-sm sm:text-base break-all"
//           >
//             codexfuturetechnologies@gmail.com
//           </a>
//         </div>

//         {/* PHONE */}
//         <div className="bg-[#111] p-6 rounded-xl text-center text-white shadow-[0_0_20px_rgba(212,175,55,0.3)] border border-[#D4AF37] hover:scale-105 transition">
//           <FiPhone className="text-green-400 text-2xl mx-auto mb-3" />

//           <a
//             href="tel:+919303715744"
//             className="text-white font-medium hover:text-green-400 text-sm sm:text-base"
//           >
//             +91 93037 15744
//           </a>
//         </div>
//       </div>
//     </section>
//   </div>
// );

// };

// export default Contact;

import React, { useState } from "react";
import { FiMail, FiPhone, FiMapPin } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import emailjs from "@emailjs/browser";
import { motion } from "framer-motion";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const navigate = useNavigate();

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .send(
        "service_fz98ect",
        "template_fyygjp7",
        {
          user_name: formData.name,
          user_email: formData.email,
          message: formData.message,
        },
        "a8Z9CQQmTYq1Zhy7j"
      )
      .then(
        () => {
          alert(`Thank you ${formData.name}, your message has been sent!`);
          setFormData({ name: "", email: "", message: "" });
        },
        (error) => {
          console.error("EmailJS Error:", error);
          alert("Oops! Something went wrong, please try again.");
        }
      );
  };

  return (
    <div className="relative w-full min-h-screen bg-black pt-6 font-sans text-white overflow-x-hidden">

      {/* TITLE */}
      <h1 className="text-center text-3xl sm:text-4xl md:text-5xl font-bold pt-16 pb-8 text-[#D4AF37] drop-shadow-[0_0_15px_rgba(212,175,55,0.4)]">
        CONTACT US
      </h1>

      {/* MAIN SECTION */}
      <section className="w-full bg-black py-12 px-4 sm:px-6 md:px-8">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-10 lg:gap-16">

          {/* LEFT */}
          <motion.div
            initial={{ opacity: 0, x: -80 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            className="flex flex-col items-center md:items-start text-center md:text-left"
          >
            <p className="uppercase text-sm text-[#f5d68a] mb-3 tracking-wide">
              Contact Us
            </p>

            <h2 className="text-3xl md:text-4xl font-bold text-[#D4AF37] leading-snug mb-6 drop-shadow-[0_0_15px_rgba(212,175,55,0.3)]">
              Let us help your business <br /> move forward.
            </h2>

            <img
              src="/con.jpeg"
              alt="illustration"
              className="w-full max-w-xs sm:max-w-sm md:max-w-md rounded-xl shadow-[0_0_25px_rgba(212,175,55,0.3)]"
            />
          </motion.div>

          {/* RIGHT - FORM */}
          <motion.div
            className="bg-[#0d0d0d] p-6 sm:p-8 md:p-10 rounded-xl shadow-[0_0_30px_rgba(212,175,55,0.4)] border border-[#D4AF37]"
            initial={{ opacity: 0, x: 80 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h3 className="text-2xl font-semibold text-center text-[#f5d68a] mb-6">
              Send Us a Message
            </h3>

            <form onSubmit={handleSubmit} className="space-y-5">

              <input
                type="text"
                name="name"
                placeholder="Your Name"
                value={formData.name}
                onChange={handleChange}
                className="w-full p-3 bg-[#1a1a1a] text-white border border-[#D4AF37] rounded-md placeholder-gray-400 focus:ring-2 focus:ring-[#D4AF37]"
                required
              />

              <input
                type="email"
                name="email"
                placeholder="Your Email"
                value={formData.email}
                onChange={handleChange}
                className="w-full p-3 bg-[#1a1a1a] text-white border border-[#D4AF37] rounded-md placeholder-gray-400 focus:ring-2 focus:ring-[#D4AF37]"
                required
              />

              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="Your Message"
                rows="5"
                className="w-full p-3 bg-[#1a1a1a] text-white border border-[#D4AF37] rounded-md placeholder-gray-400 focus:ring-2 focus:ring-[#D4AF37]"
                required
              ></textarea>

              <motion.button
                whileHover={{ scale: 1.05 }}
                type="submit"
                className="w-full bg-[#D4AF37] text-black py-3 rounded-md font-medium hover:bg-[#f5d68a] transition"
              >
                Submit Now
              </motion.button>
            </form>
          </motion.div>
        </div>
      </section>

      {/* INFO BOXES */}
      <section className="w-full bg-black py-14 px-4 sm:px-6 md:px-8">
        <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">

          {/* OFFICE */}
          <div className="bg-[#111] p-6 rounded-xl text-center text-white shadow-[0_0_20px_rgba(212,175,55,0.3)] border border-[#D4AF37] hover:scale-105 transition duration-300">
            <FiMapPin className="text-red-600 text-3xl mx-auto mb-3" />
            <h4 className="font-semibold mb-1">Our Office</h4>
            <p className="opacity-90 text-sm">Indore, MP</p>
          </div>

          {/* EMAIL */}
          <div className="bg-[#111] p-6 rounded-xl text-center text-white shadow-[0_0_20px_rgba(212,175,55,0.3)] border border-[#D4AF37] hover:scale-105 transition duration-300">
            <FiMail className="text-red-400 text-2xl mx-auto mb-3" />
            <p className="text-white font-medium text-sm break-all">
              codexfuturetechnologies@gmail.com
            </p>
          </div>

          {/* PHONE */}
          <div className="bg-[#111] p-6 rounded-xl text-center text-white shadow-[0_0_20px_rgba(212,175,55,0.3)] border border-[#D4AF37] hover:scale-105 transition duration-300">
            <FiPhone className="text-green-400 text-2xl mx-auto mb-3" />
            <p className="text-white font-medium text-sm">
              +91 93037 15744
            </p>
          </div>

        </div>
      </section>
    </div>
  );
};

export default Contact;
